module.exports = __webpack_public_path__ + "static/media/statusOffline.7c3353ff.svg";